import { defineCoach } from '../../types';
import { PERMISSIONS, canAll } from '../tasks/access';

/** C05: observes the person’s real workflow; navigation is read-only and mutations belong to the page. Arabic copy is DRAFT. */
export const C05 = defineCoach({
  id: 'C05',
  version: 1,
  portal: 'tenant',
  titleKey: 'guidance.coaches.C05.title',
  summaryKey: 'guidance.coaches.C05.summary',
  eligible: (ctx) =>
    ctx.portal === 'tenant' && canAll(ctx, PERMISSIONS.receiptView, PERMISSIONS.receiptRecord),
  steps: [
    {
      id: 'c05-welcome',
      kind: 'explain',
      page: 'tenant.receiving',
      anchor: null,
      titleKey: 'guidance.coaches.C05.welcome.title',
      bodyKey: 'guidance.coaches.C05.welcome.body',
      route: 'tenant.receiving',
    },
    {
      id: 'c05-open',
      kind: 'await',
      page: 'tenant.receiving',
      anchor: 'tenant.receiving.queue',
      titleKey: 'guidance.coaches.C05.open.title',
      bodyKey: 'guidance.coaches.C05.open.body',
      until: {
        route: 'tenant.receive',
      },
    },
    {
      id: 'c05-facts',
      kind: 'explain',
      page: 'tenant.receive',
      anchor: 'tenant.receive.facts',
      titleKey: 'guidance.coaches.C05.facts.title',
      bodyKey: 'guidance.coaches.C05.facts.body',
    },
    {
      id: 'c05-lines',
      kind: 'explain',
      page: 'tenant.receive',
      anchor: 'tenant.receive.lines',
      titleKey: 'guidance.coaches.C05.lines.title',
      bodyKey: 'guidance.coaches.C05.lines.body',
    },
    {
      id: 'c05-details',
      kind: 'explain',
      page: 'tenant.receive',
      anchor: 'tenant.receive.delivery-details',
      titleKey: 'guidance.coaches.C05.details.title',
      bodyKey: 'guidance.coaches.C05.details.body',
    },
    {
      id: 'c05-record-handoff',
      kind: 'handoff',
      page: 'tenant.receive',
      anchor: 'tenant.receive.commit',
      titleKey: 'guidance.coaches.C05.record-handoff.title',
      bodyKey: 'guidance.coaches.C05.record-handoff.body',
      consequenceKey: 'guidance.coaches.C05.record-handoff.consequence',
    },
    {
      id: 'c05-record',
      kind: 'await',
      page: 'tenant.receive',
      anchor: 'tenant.receive.commit',
      titleKey: 'guidance.coaches.C05.record.title',
      bodyKey: 'guidance.coaches.C05.record.body',
      until: {
        outcome: 'receipt.recorded',
        route: 'tenant.receive',
        probe: {
          anchor: 'tenant.receive.recorded',
          in: ['recorded'],
        },
      },
    },
    {
      id: 'c05-history',
      kind: 'explain',
      page: 'tenant.receive',
      anchor: 'tenant.receive.history',
      titleKey: 'guidance.coaches.C05.history.title',
      bodyKey: 'guidance.coaches.C05.history.body',
    },
    {
      id: 'c05-finish',
      kind: 'finish',
      page: 'tenant.receive',
      anchor: null,
      titleKey: 'guidance.coaches.C05.finish.title',
      bodyKey: 'guidance.coaches.C05.finish.body',
    },
  ],
});
